import React, { useState, useEffect } from "react";
import {
  IoIosAddCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoMdCreate,
} from "react-icons/io";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import {
  addStudentCertificate,
  fetchStudentCertificates,
  fetchStudentLearningTracks,
  updateStudentCertificate,
} from "../../services/studentportalapis";

const Assessment = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);
  const [form, setForm] = useState({
    certificateName: "",
    issueDate: "",
    issuingAuthority: "",
    description: "",
    certificateUrl: "",
    certificateFile: null,
    certificateIndex: -1, // To track which certificate is being edited
  });

  useEffect(() => {
    // Fetch certificates from the API when the component mounts
    const fetchCertificates = async () => {
      try {
        const studentId = JSON.parse(localStorage.getItem("student-details"))[
          "studentId"
        ];
        const data = await fetchStudentCertificates(studentId); // Call API to fetch certificates
        setCertificates(data); // Update state with the fetched certificates
      } catch (error) {
        console.error("Failed to fetch certificates:", error);
      }
    };

    fetchCertificates();
  }, []);

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const studentId = JSON.parse(localStorage.getItem("student-details"))[
          "studentId"
        ];

        const data = await fetchStudentLearningTracks(studentId);

        setCourseDetails(data);
      } catch (error) {
        console.error("Failed to fetch course details:", error);
      }
    };

    fetchCourseDetails();
  }, []);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (event) => {
  const selectedFile = event.target.files[0];

  if (selectedFile) {

    console.log("Selected file:", selectedFile);

    // Allowed MIME types
    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

    // Validate MIME type
    if (!allowedTypes.includes(selectedFile.type)) {
      alert("Invalid file type. Please upload only PDF or image files (JPG, JPEG, PNG).");
      event.target.value = ""; // Clear the input value
      return;
    }

    // Optionally validate file extension
    const allowedExtensions = [".pdf", ".jpg", ".jpeg", ".png"];
    const fileExtension = selectedFile.name.substring(selectedFile.name.lastIndexOf(".")).toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      alert("Invalid file extension. Please upload only PDF or image files (JPG, JPEG, PNG).");
      event.target.value = ""; // Clear the input value
      return;
    }

    // File is valid, update form state
    setForm({ ...form, certificateFile: selectedFile });
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    
      const studentId = JSON.parse(localStorage.getItem("student-details"))["studentId"]; // Replace with actual student ID
      
  
      const formData = new FormData();
      formData.append("certificateName", form.certificateName);
      formData.append("issueDate", form.issueDate);
      formData.append("issuingAuthority", form.issuingAuthority);
      formData.append("description", form.description);
      formData.append("certificateUrl", form.certificateUrl);
      if (form.certificateFile) {
        formData.append("certificateFile", form.certificateFile);
      }
  
     
      try {
    let response;
    const certificateId = certificates[form.certificateIndex]?.certificateId; // Safely access id here

    // if (!certificateId) {
    //   throw new Error("Certificate ID is missing");
    // }

    if (form.certificateIndex === -1) {
      // If it's a new certificate, call addStudentCertificate API
      response = await addStudentCertificate(studentId, formData);
      setCertificates([...certificates, response]); // Add the new certificate to the list
    } else {
      // If it's an update, call the updateStudentCertificate API
      // const certificateId = certificates[form.certificateIndex].id;
      console.log(typeof(certificateId))
      response = await updateStudentCertificate(studentId, certificateId, formData);
      
      // Update the certificate in the local state
      const updatedCertificates = [...certificates];
      updatedCertificates[form.certificateIndex] = response;
      setCertificates(updatedCertificates);
    }
    
    setForm({
      certificateName: "",
      issueDate: "",
      issuingAuthority: "",
      description: "",
      certificateUrl: "",
      certificateFile: null,
      certificateIndex: -1,
    });
    togglePopup();
  } catch (error) {
    console.error("Failed to save certificate:", error);
  }
};
  

const handleEdit = (index) => {
  const certToEdit = certificates[index];
  console.log(certToEdit); // Print the certificate object to check its structure

  if (certToEdit) {
    setForm({
      ...certToEdit,
      certificateIndex: index, // Set the index of the certificate being edited
      certificateFile: null,    // Don't overwrite the file during editing
    });
    togglePopup();
  } else {
    console.error("Certificate not found for the selected index:", index);
  }
};


  return (
    <div className="w-full">
      {/* Accordion */}
      <button
        className="w-full flex items-center justify-between font-bold text-2xl px-4 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition text-left"
        onClick={togglePopup}
      >
        Add Technical Certifications
        <IoIosAddCircleOutline className="text-3xl" />
      </button>

      {/* Popup Form */}
      {isPopupOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="relative bg-white rounded-lg shadow-lg w-[90%] sm:w-[50%] max-h-[85vh] overflow-auto scrollbar-hide
            [&::-webkit-scrollbar]:[width:10px]
            [&::-webkit-scrollbar-thumb]:bg-transparent
            [&::-webkit-scrollbar-thumb]:[border-radius:10px]
            overflow-x-hidden "
          >
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-2 rounded-t-lg">
              <div className="text-xl font-bold text-blue-900 text-center ">
                {form.certificateIndex === -1
                  ? "Add Certification"
                  : "Edit Certification"}
              </div>
              <button
                onClick={togglePopup}
                className="bg-transparent text-blue-900 text-2xl"
              >
                &times;
              </button>
            </div>

            {/* Form */}
            <div className="px-6">
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                    Certification Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="certificateName"
                    value={form.certificateName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="e.g., Google Cloud Professional"
                  />
                </div>

                <div className="mb-4 flex gap-4 flex-col md:flex-row">
                  <div className="flex-1">
                    <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                      Issued Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="issueDate"
                      value={form.issueDate}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>

                  <div className="flex-1">
                    <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                      Issuing organization{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="issuingAuthority"
                      value={form.issuingAuthority}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      placeholder="e.g., Google, AWS"
                    />
                  </div>
                </div>
                <div className="flex justify-between gap-4">
                  <div className="mb-4 flex-1">
                    <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                      Certificate URL
                    </label>
                    <input
                      type="text"
                      name="certificateUrl"
                      value={form.certificateUrl}
                      onChange={handleInputChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none h-[42px]" // Ensuring consistent height
                      placeholder="e.g., https://www.udemy.com/certificate/UC-c..."
                    />
                  </div>

                  <div className="mb-4 flex-1">
                    <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                      Upload Certificate <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={handleFileChange}
                      className="w-full px-4 py-2 border text-sm border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none h-[42px]" // Matching height with text input
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium !text-gray-700 mb-1 text-left">
                    Description (Optional)
                  </label>
                  <textarea
                    name="description"
                    value={form.description}
                    onChange={handleInputChange}
                    rows="4"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    placeholder="Brief description about the certification"
                  ></textarea>
                </div>

                {/* Buttons */}
                <div className="flex justify-end space-x-2 mb-2">
                  <button
                    type="button"
                    onClick={togglePopup}
                    className="px-4 py-2 bg-gray-300 !text-gray-700 rounded-md hover:bg-gray-400 transition"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition"
                  >
                    {form.certificateIndex === -1
                      ? "Add Certification"
                      : "Update Certification"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="mt-4 p-2 rounded-md">
        {certificates.length === 0 ? (
          <p className="text-center text-gray-600">
            No certificates added yet.
          </p>
        ) : (
          <ul className="space-y-2">
            {certificates.map((cert, index) => (
              <li
                key={index}
                className="p-3 bg-white border border-gray-200 rounded-md flex items-center justify-between"
              >
                {/* Certificate Info */}
                <div className="flex flex-row justify-between w-full">
                  <div className="flex-col">
                    <div className="text-lg font-semibold text-left">
                      {cert.certificateName}
                    </div>
                    <div className="text-sm text-gray-600 font-semibold text-left">
                      {cert.issuingAuthority}
                    </div>
                    <div className="text-sm text-gray-500 text-left">
                      Issued Date: {cert.issueDate}
                    </div>

                    {/* Show Credential Button */}
                    {cert.certificateUrl && (
                      <a
                        href={cert.certificateUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center mt-2 px-4 py-1 text-sm rounded-full border-2 border-gray-600 bg-transparent hover:bg-blue-100 transition"
                      >
                        <span className="font-semibold">Show Credential</span>
                        <FaArrowUpRightFromSquare className="ml-2" />
                      </a>
                    )}
                  </div>

                  {/* Certificate Uploaded Indicator */}
                  <div className="flex flex-col items-end">
                    <div className="flex justify-end w-full">
                      <button
                        onClick={() => handleEdit(index)}
                        className="text-xl text-black bg-transparent"
                      >
                        <IoMdCreate />
                      </button>
                    </div>
                    {cert.certificateFile && (
                      <div className="flex items-center space-x-2 mt-2">
                        <span className="text-green-600 text-sm font-medium">
                          Certificate Uploaded
                        </span>
                        <IoIosCheckmarkCircleOutline className="ml-1 text-xl text-green-600" />
                      </div>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      
    </div>
  );
};

export default Assessment;
